// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1DcvV","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__LNsnQ","gfeWrapper":"CalendarEvent_gfeWrapper__p6VWz"};